import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	titleHeader: {
		id: 'servicedesk.knowledge-hub.common.knowledge-table.title-header',
		defaultMessage: 'Article',
		description: 'Header for the title column in an article table',
	},
	viewCountHeader: {
		id: 'servicedesk.knowledge-hub.common.knowledge-table.view-count-header',
		defaultMessage: 'Views',
		description: 'Header for the view count column in an article table',
	},
	lastModifiedHeader: {
		id: 'servicedesk.knowledge-hub.common.knowledge-table.last-modified-header',
		defaultMessage: 'Last updated',
		description: 'Header for the last modified column in an article table',
	},
	actionsHeader: {
		id: 'servicedesk.knowledge-hub.common.knowledge-table.actions-header',
		defaultMessage: 'Actions',
		description: 'Header for the actions column in an article table',
	},
	paginationPrev: {
		id: 'servicedesk.knowledge-hub.common.knowledge-table.pagination-prev',
		defaultMessage: 'Prev',
		description: 'Text for going to the previous page in the browse table',
	},
	paginationNext: {
		id: 'servicedesk.knowledge-hub.common.knowledge-table.pagination-next',
		defaultMessage: 'Next',
		description: 'Text for going to the next page in the browse table',
	},
	linkedSpacesHeader: {
		id: 'servicedesk.knowledge-hub.commin.knowledge-table.linked-spaces-header',
		defaultMessage: 'Space',
		description: 'Header for the linked spaces in the table',
	},
	tooltipText: {
		id: 'servicedesk.knowledge-hub.commin.knowledge-table.tooltip-text',
		defaultMessage: 'Opens in new tab',
		description: 'tooltip text for spaces column',
	},
	paginationLabel: {
		id: 'servicedesk.knowledge-hub.common.knowledge-table.pagination-label',
		defaultMessage: 'Page',
		description: 'Label for pagination component',
	},
});
